import React from "react";
import { Flex, Text, useDisclosure } from "@chakra-ui/react";
import { Button } from "ui/button";
import { TextTitle } from "ui/text";
import Balancer from "react-wrap-balancer";
import { AgentsVideo } from "./agents-video";

export function AgentsMobileVideo() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Flex display={{ base: "block", md: "none" }} direction="column" align="center" justify="center" mt="biggest">
      <TextTitle
        size="md"
        mobileAlign="center"
        titleAs="div"
        title={
          <Text as="h2" fontSize="24px">
            <Balancer>
              We believe AI can help marketers move 10x faster by augmenting every step of the process
            </Balancer>
          </Text>
        }
        actions={
          <Button hasRightChevron variant="darkBlue" onClick={onOpen}>
            Watch video
          </Button>
        }
      />

      <AgentsVideo hasPlayButton={false} borderRadius="smaller" isOpen={isOpen} onOpen={onOpen} onClose={onClose} />
    </Flex>
  );
}
